import { render, staticRenderFns } from "./rentModal.vue?vue&type=template&id=6228753e&"
import script from "./rentModal.vue?vue&type=script&lang=js&"
export * from "./rentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports